import { render, staticRenderFns } from "./articlenameelement.vue?vue&type=template&id=66b00482&"
import script from "./../../ts/articleattributes/articlenameelement.ts?vue&type=script&lang=js&"
export * from "./../../ts/articleattributes/articlenameelement.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports